import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import StaffLayout from "@/pages/staff/StaffLayout";
import api, { formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "@/components/ui/table";
import { Search } from "lucide-react";

export default function PatientSearchPage() {
  const [search, setSearch] = useState("");
  const [result, setResult] = useState({ patients: [], total: 0 });
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/patients", { params: { search, sort_by: "created_at", sort_dir: "desc", page_size: 30 } }).then(({ data }) => setResult(data));
  }, [search]);

  return (
    <StaffLayout>
      <h1 className="text-2xl font-semibold text-slate-900" data-testid="patient-search-page-heading">Patient Search</h1>
      <div className="relative mt-4 max-w-md">
        <Search className="absolute left-3 top-2.5 h-4 w-4 text-slate-400" />
        <Input
          data-testid="staff-patient-search-input"
          placeholder="Search by name, patient ID, mobile, age, DOB, address..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="pl-9"
        />
      </div>
      <div className="mt-4">
        <Table>
          <TableHeader>
            <TableRow className="sticky top-0">
              <TableHead>Patient ID</TableHead>
              <TableHead>Name</TableHead>
              <TableHead>Mobile</TableHead>
              <TableHead>Age</TableHead>
              <TableHead>Address</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {result.patients.map((p, i) => (
              <TableRow key={p.id} data-testid={`staff-patient-row-${p.patient_code}`}>
                <TableCell className="font-mono text-xs">{p.patient_code}</TableCell>
                <TableCell>
                  <button className="font-medium text-teal-700 hover:underline" onClick={() => navigate(`/staff/patients/${p.id}`)}>
                    {p.full_name}
                  </button>
                </TableCell>
                <TableCell>{p.mobile}</TableCell>
                <TableCell>{p.age ?? "-"}</TableCell>
                <TableCell className="text-slate-600">{p.address || "—"}</TableCell>
              </TableRow>
            ))}
            {result.patients.length === 0 && (
              <TableRow><TableCell colSpan={5} className="py-8 text-center text-slate-400">No patients found.</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </StaffLayout>
  );
}
